import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class PushService {

  constructor(private http: HttpClient) { }

  list(params: any): Observable<any> {
    return this.http.get('/api/push', { params });
  }

  get(id: number): Observable<any> {
    return this.http.get('/api/push/' + id);
  }

  create(data: any): Observable<any> {
    return this.http.post('/api/push', data);
  }

  update(id: number, data: any): Observable<any> {
    return this.http.put('/api/push/' + id, data);
  }

  delete(id: number): Observable<any> {
    return this.http.delete('/api/push/' + id);
  }

  cancel(id: number): Observable<any> {
    return this.http.post('/api/push/' + id + '/cancel', {});
  }

  getLogs(id: number, params?: any): Observable<any> {
    return this.http.get('/api/push/' + id + '/logs', { params });
  }

  getTemplates(): Observable<any> {
    return this.http.get('/api/push/templates');
  }

  getConfig(): Observable<any> {
    return this.http.get('/api/push/config');
  }

  updateConfig(data: any): Observable<any> {
    return this.http.put('/api/push/config', data);
  }

  sendWeather(): Observable<any> {
    return this.http.post('/api/push/weather', {});
  }
}



// WEBPACK FOOTER //
// ./src/app/services/push.service.ts